import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/agents/performance")({
  component: () => (
    <PlaceholderPanel
      title="Performance Analytics"
      description="Per-agent time-series, company-level aggregates, function-level aggregates, trend indicators, cohort benchmarking"
    />
  ),
})
